import React from "react";
import { Routes, Route, Navigate } from "react-router-dom";
import NavBar from "./components/NavBar";
import ProtectedRoute from "./router/ProtectedRoute";
import { useAuth } from "./auth/AuthContext";

import RemoteControl from "./Pages/RemoteControl/RemoteControl";
import XRVAApp from "./Pages/VideoAudioPage/XRVAApp";
import Login from "./Pages/Login/Login";
import SystemInformation from "./Pages/SystemInformation/SystemInformation";
import ErrorPage from "./Pages/ErrorPage";

function LoginRoute() {
  const { isAuth, loading } = useAuth();
  if (loading) return null;
  return isAuth ? <Navigate to="/rcu" replace /> : <Login />;
}

export default function App() {
  return (
    <>
      <NavBar />
      <Routes>
        <Route element={<ProtectedRoute />}>
          <Route path="/rcu" element={<RemoteControl />} />
          <Route path="/video" element={<XRVAApp />} />
          <Route path="/system-information" element={<SystemInformation />} />
          <Route path="/" element={<Navigate to="/rcu" replace />} />
          <Route path="*" element={<ErrorPage />} />
        </Route>
        <Route path="/login" element={<LoginRoute />} />
      </Routes>
    </>
  );
}
